module.exports = __webpack_public_path__ + "img/financial-aid.16de6da1.jpg";